export default __webpack_public_path__ + "static/media/notFound.745710b4.png";